<template>
    <div v-if="!isOnline" class="offline-banner">
        <span class="material-symbols-outlined offline-banner-icon">wifi_off</span>
        <span class="offline-banner-text">You are offline — some features may be unavailable</span>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { pwaStore } from './PwaStore.js'

const isOnline = computed(() => pwaStore.isOnline)
</script>

<style scoped>
.offline-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 16px;
    background: #f26560;
    color: #ffffff;
    font-size: 13px;
    font-weight: 500;
    position: sticky;
    top: 0;
    z-index: 9998;
}

.offline-banner-icon {
    font-size: 18px;
}
</style>
